import React, { useRef, useEffect } from "react";
import { setCSSVar } from "../../util/colorUtil";
import useElementHeight from "../hooks/useElementHeight";
import {
  isMobileClass,
  isMobileOrTablet,
  isBrowserView,
} from "../Views/MobileClassRenderer";

export default function BackgroundImageView({ backgroundImage, isVideoType }) {
  const ref = useRef(null);
  const [height] = useElementHeight(ref);

  useEffect(() => {
    if (typeof height === "number")
      setCSSVar("video-height", `calc(${height}px + 1.4rem)`);
  }, [height]);

  return (
    <>
      {isBrowserView() && (
        <div
          className={isMobileClass("image")}
          style={{
            backgroundImage: `url(${backgroundImage ? backgroundImage : ""})`,
          }}
          data-bg={backgroundImage ? backgroundImage : ""}
        ></div>
      )}

      {isMobileOrTablet() && !isVideoType && (
        <div
          ref={ref}
          className={isMobileClass("image")}
          style={{
            backgroundImage: `url(${backgroundImage ? backgroundImage : ""})`,
            paddingTop: "56.25%",
            position: "relative",
          }}
          data-bg={backgroundImage ? backgroundImage : ""}
        ></div>
      )}
    </>
  );
}
